<!--
 * @Author: 赵辛淋
 * @Date: 2023-05-10 15:19:53
 * @LastEditTime: 2023-11-02 09:51:02
 * @Description: 脱敏组件
-->
<template>
  <div class="insensitive">
    <div class="infodisplay">
      <div>{{ isShow ? val : showVal }}</div>
      <div class="img-container" v-if="showEye" @click="handleShowInfo">
        <img class="toggle-icon" v-if="!isShow" src="../assets/images/hide.png" />
        <img class="toggle-icon" v-else src="../assets/images/show.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShowEye: {
      type: Boolean,
      default: true
    },
    val: [ String, Number ],
    type: [ String ]
  },
  data() {
    return {
      isShow: false
    };
  },
  computed: {
    showEye() {
      if(['name','address','fullAddress'].includes(this.type)&&this.isShowEye){
        return true;
      }else{
        return this.isShowEye && /^(.{3})(?:\d+)(.{3})$/.test(this.val);
      }
    },
    showVal() {
      if(this.type==='name'){
        return this.nameDesensitization(this.val);
      }
      if(this.type==='address'){
        return '********';
      }
      if(this.type==='fullAddress'){
        return this.val.slice(0,-8)+'********';
      }
      return (this.val || '').replace(/^(.{3})(?:\d+)(.{3})$/, '$1*****$2');
      // let result;
      // switch (this.type) {
      //   case 'phone':
      //     result = this.val.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
      //     break;
      //   case 'idCard':
      //     result = this.val.replace(/^(\d{4})\d{10}(\w{4})$/, '$1**********$2');
      //     break;
      //   case 'bankCard':
      //     if (this.val.length < 10) {
      //       result = this.val; // 长度小于10的银行卡号不进行脱敏
      //     } else {
      //       const visibleDigits = 6;
      //       const maskedDigits = this.val.length - visibleDigits - 4;
      //       const maskedPart = '*'.repeat(maskedDigits);
      //       result = this.val.substring(0, visibleDigits) + maskedPart + this.val.slice(-4);
      //     }
      //     break;
      //   default:
      //     result = this.val;
      //     break;
      // }
      // return result;
    }
  },
  methods: {
    handleShowInfo() {
      this.isShow = !this.isShow;
    },
    nameDesensitization(str){
      if(null == str || str == undefined || str.length == 0){
        return ''
      }
      if(str.length == 1) {
        return str
      }
      if(str.length == 2){
        return str.substring(0,1)+'*' //截取name 字符串截取第一个字符，
      }

      let starStr = ''
      for (let index = 0; index < str.length - 2; index++) {
        starStr += "*"
      }
      return str.substring(0, 1) + starStr + str.substring(str.length - 1, str.length)
    },
  }
};
</script>
<style scoped>
.insensitive{
  display: inline-block;
}
.infodisplay {
  display: flex;
  align-items: center;
}

.img-container {
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.toggle-icon {
  width: 20px;
  height: auto;
}
</style>
